import * as React from 'react';
import { observer } from 'mobx-react';

import {
  useManagerNotificationsStore,
  useProjectStore,
  useUiStore
} from 'stores';
import MenuSection from 'shared/newComponents/MenuSection';
import FadeScroll from 'shared/newComponents/FadeScroll';
import { usePageTemplateMenuStore } from 'stores/PageTemplateMenuStore';
import { ComponentType } from 'shared/entities/components/Component';
import { urls } from 'shared/entities/domain';

import styles from './Sections.modules.scss';

type Props = {
  className?: string;
};

const Sections: React.FC<Props> = ({ className }) => {
  const uiStore = useUiStore();
  const projectStore = useProjectStore();

  const menuStore = usePageTemplateMenuStore();
  const managerNotificationsStore = useManagerNotificationsStore();
  const isMenuClosed = !uiStore.menuState.opened;

  return (
    <FadeScroll
      className={className}
      contentClassname={
        isMenuClosed
          ? styles['sections__scroll-content_menu-closed']
          : undefined
      }
    >
      {menuStore.sections.map((section, idx) => {
        const isConversationsSection =
          section.action.type === ComponentType.link &&
          section.action.mask === urls.PROJECT.tabs.CONVERSATIONS.mask;

        return (
          <MenuSection
            hidden={!uiStore.menuState.opened}
            key={idx}
            onClick={uiStore.isMobileSize ? uiStore.menuState.close : undefined}
            disabled={!projectStore.projectId}
            {...section}
            withAttentionMark={
              isConversationsSection &&
              managerNotificationsStore.hasUnreadNotifications
            }
          />
        );
      })}
    </FadeScroll>
  );
};

export default observer(Sections);
